import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import BaseModal from './Base';
import Button from '../../Button';
import Row from '../../Row';
import {_removeModal} from '../../../store';
import DescriptiveText from '../../DescriptiveText';

class MessageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: props.content,
    };
    this.executeAction = this.executeAction.bind(this);
  }

  executeAction() {
    const {button} = this.state.content;
    if (button && button.action) {
      button.action(button.data);
    }
    this.props.removeModal(this.state.content);
  }

  render() {
    const {content} = this.state;
    const {removeModal} = this.props;
    return <BaseModal onClose={() => removeModal(content)} size={content.size} title={content.title || 'An Issue Occurred'}>
      <DescriptiveText>{content.body}</DescriptiveText>
      <Row wrap={true}>
        <Button importance={'primary'}
                size={content.button && content.button.size || 'lg'}
                label={(content.button && content.button.text) || 'OK'}
                disabled={false}
                action={this.executeAction}/>
      </Row>
    </BaseModal>;
  }
}

const mapDispatchToProps = dispatch => ({
  removeModal: modal => {
    dispatch(_removeModal(modal));
  },
});

export default connect(null, mapDispatchToProps)(MessageModal);
MessageModal.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    body: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ]).isRequired,
    button: PropTypes.shape({
      text: PropTypes.string,
      action: PropTypes.func,
      data: PropTypes.object,
      size: PropTypes.string,
    }),
  }).isRequired,
  removeModal: PropTypes.func.isRequired,
};
